import { useEffect, useMemo } from 'react';
import { atomFamily, useRecoilCallback, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { clearDrawFilterCallback, configState, floorPlansState, mapExtentFilterEnabledState, recordFilterState, selectedFloorPlanState, selectedItemsState } from '../recoil/atoms';
import { initializeRecoilFamilyCallback, InitializeRecoilValueOptions } from '../recoil/initialization';

export interface RecoilRootEffectsProps {
  initializeOptions?: InitializeRecoilValueOptions;
}
export const RecoilRootEffects = ({ initializeOptions }: RecoilRootEffectsProps) => {
  const config = useRecoilValue(configState);
  const selectedItems = useRecoilValue(selectedItemsState);
  const floorPlans = useRecoilValue(floorPlansState);
  const [selectedFloorPlan,setSelectedFloorPlan] = useRecoilState(selectedFloorPlanState);
  const setMapExtentsEnabled = useSetRecoilState(mapExtentFilterEnabledState);
  const clearDrawFilter = useRecoilCallback(clearDrawFilterCallback);

  const initializeRecoilFamily = useRecoilCallback(initializeRecoilFamilyCallback, []);

  const recordTypeNames = useMemo(() => config.aggregateDefinitions.map(a => a.name), [config]);

  useEffect(() => {
    initializeRecoilFamily(recordFilterState as ReturnType<typeof atomFamily>, recordTypeNames, initializeOptions);
  }, [recordTypeNames]);

  useEffect(() => {
    if (selectedItems.length) {
      const floorPlanId = selectedItems[0].floorPlanId;
      setSelectedFloorPlan(prev => prev?.id !== floorPlanId ? (floorPlans.find(x => x.id === floorPlanId) ?? null) : prev);
    }
  }, [selectedItems, floorPlans]);

  useEffect(() => {
    setMapExtentsEnabled(prev => !!prev === !!selectedFloorPlan ? prev : !!selectedFloorPlan);
    clearDrawFilter();
  }, [selectedFloorPlan]);

  return <></>;
};
